// userrole edit

import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid,  TextField, Button, Select, MenuItem, } from '@mui/material';

import axios from 'axios';
import { ThemeProvider } from '@mui/material';
import getTheme from '../../theme/theme';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BASEURL,ARROW } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';


interface UserRole {
  id: number | undefined; // Update id to accept undefined
  rolename: string;
  status: string;
  projectaccess: string;
  scheduleaccess: string;
  modulesaccess: string;
  reportsaccess: string;
  note: string;
  createdon: string | Date | null; // Update the type to accept string or Date
  [key: string]: string | number | null | Date | string | undefined;
}


const theme = getTheme();

const ViewRolePage = () => {
  const [userRole, setUserRole] = useState<UserRole | null>(null);
  const [editedUserRole, setEditedUserRole] = useState<UserRole | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState<string | null>(null); // Updated the type of error to string or null
  const [pageTitle, setPageTitle] = useState('View Role'); // State for dynamic page title
  const [isSaving, setIsSaving] = useState(false);
  //code to fetch latest created user role data

  const location = useLocation();
  const roleId = new URLSearchParams(location.search).get('role_id');
  const storedAdmindata = localStorage.getItem('userRoleAdmin');
  let UserroleAdmin: any = null;

  if (storedAdmindata) {
    UserroleAdmin = JSON.parse(storedAdmindata);
  } else {
    console.log('No data found in localStorage');
  }
  const [userRoleedit, setUserRoleedit] = useState<string>(UserroleAdmin);
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await axios.get( BASEURL + `/userrole/${roleId}/`);
        setUserRole(response.data);
        setEditedUserRole(response.data);
        setError(null); // Clear any previous errors if successful
      } catch (error) {
        console.error('Error fetching user role:', error);
        setError('Failed to fetch user role details'); // Set error message
      }
    };

    if (roleId) {
      fetchUserRole();
    }
  }, [roleId]);

  const handleEdit = () => {
    setIsEditing(true);
    setPageTitle('Edit Role'); // Change page title when entering edit mode
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
     
      const response = await axios.put( BASEURL + `/userrole/${roleId}/`, editedUserRole);
      setUserRole(response.data);
      setIsEditing(false);
      setError(null);
      toast.success('Userrole updated successfully');
    } catch (error) {
      setIsSaving(false);
      console.error('Error saving user role:', error);
      setError('Failed to save changes');
    }finally {
      setIsSaving(false); // Ensure the button is re-enabled after the save operation completes
    }
  };

  const handleCancel = () => {
    setEditedUserRole(userRole); // Reset editedUserRole to original values
    setIsEditing(false);
    setPageTitle('View Role'); // Change page title when canceling edit mode
  };


  const ACCESS_CHOICES = ['No Access', 'View Only', 'Edit', 'Owner'];
  const STATUS_CHOICES = ['Active', 'Inactive'];
  const REPORT_ACCESS_CHOICES = ['No Access', 'Owner'];



const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

const isUserAdmin = userRoleedit  === 'Admin';

console.log("isUserAdminedit",isUserAdmin);
  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px', display: 'flex', flexDirection: 'column' }}>
        {userRole ? (
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '10px',
              }}
            >
              <Typography variant='h6' gutterBottom>
              <Link to={'/userrole'}>User Role</Link> {ARROW}  {pageTitle}
              </Typography>
              {!isEditing ? (
                <Button variant='contained'
                 onClick={handleEdit}
                 disabled={!isUserAdmin}
                  aria-label="edit"
                  sx={{
                    textTransform: 'uppercase',
                    color: theme.palette.common.black,
                    '&:disabled': {
                      // Adding styles for disabled state
                      color: theme.palette.grey[500],
                    },
                  }}>
                  Edit
                </Button>
              ) : (
                null)}
          </Box>
               
            
            
              {/* Render editable fields based on isEditing */}
              {isEditing ? (
                <>
                <Grid container spacing={2} sx={{ marginTop: '16px', marginLeft: '10px' }}>
                   <Grid item xs={12} sx={{ mb: '10px', }}>
                   <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Role Name:</Typography>
                  </Grid>
                  <Grid item xs={8} sx={{maxWidth:'350px'}}>
                    <TextField
                      
                      value={editedUserRole?.rolename || ''}
                      onChange={(e) =>
                        setEditedUserRole((prev) => ({
                          ...prev,
                          id: userRole ? userRole.id : undefined,
                          rolename: e.target.value,
                          status: editedUserRole?.status || '',
                          projectaccess: editedUserRole?.projectaccess || '',
                          scheduleaccess: editedUserRole?.scheduleaccess || '',
                          modulesaccess: editedUserRole?.modulesaccess || '',
                          reportsaccess: editedUserRole?.reportsaccess || '',
                          note: editedUserRole?.note || '',
                          createdon: editedUserRole?.createdon || '',
                        }))
                      }
                      sx={{
                        width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
                        maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
                      }}
                      fullWidth
                    />
                  </Grid>
                  </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Status:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                   
                  <Select
 value={editedUserRole?.status || ''}
 onChange={(e) =>
   setEditedUserRole((prev) => ({
     ...prev,
     status: e.target.value,
     id: userRole?.id || undefined,
     rolename: editedUserRole?.rolename || '',
     projectaccess: editedUserRole?.projectaccess || '',
     scheduleaccess: editedUserRole?.scheduleaccess || '',
     modulesaccess: editedUserRole?.modulesaccess || '',
     reportsaccess: editedUserRole?.reportsaccess || '',
     note: editedUserRole?.note || '',
     createdon: editedUserRole?.createdon || '',
   }))

  }
   sx={{
      width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
      maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
    }}
  fullWidth
>
  {STATUS_CHOICES.map((option) => (
    <MenuItem key={option} value={option}>
      {option}
    </MenuItem>
  ))}
</Select>
                    
                     </Grid>
                     </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Note:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      value={editedUserRole?.note || ''}
                      multiline
                      rows={3}
  onChange={(e) =>
    setEditedUserRole((prev) => ({
      ...prev,
      note: e.target.value,
      id: userRole?.id || undefined,
      rolename: editedUserRole?.rolename || '',
      projectaccess: editedUserRole?.projectaccess || '',
      scheduleaccess: editedUserRole?.scheduleaccess || '',
      modulesaccess: editedUserRole?.modulesaccess || '',
      reportsaccess: editedUserRole?.reportsaccess || '',
      status: editedUserRole?.status || '',
      createdon: editedUserRole?.createdon || '',
    }))
  }
  sx={{
    width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
    maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
  }}
                      fullWidth
                    />
                    </Grid>
                     </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={4} >
                    <Typography>Project Access:</Typography>
                  </Grid>
                   <Grid item xs={8} >
                   <Select
  value={isEditing ? editedUserRole?.projectaccess : userRole?.projectaccess || ''}
  onChange={(e) =>
    setEditedUserRole((prev) => ({
      ...prev,
      projectaccess: e.target.value,
      id: userRole?.id || undefined,
      rolename: editedUserRole?.rolename || '',
      note: editedUserRole?.note || '',
      scheduleaccess: editedUserRole?.scheduleaccess || '',
      modulesaccess: editedUserRole?.modulesaccess || '',
      reportsaccess: editedUserRole?.reportsaccess || '',
      status: editedUserRole?.status || '',
      createdon: editedUserRole?.createdon || '',
    }))
  }
   sx={{
      width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
      maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
    }}
  fullWidth
>
  {ACCESS_CHOICES.map((option) => (
    <MenuItem key={option} value={option}>
      {option}
    </MenuItem>
  ))}
</Select>
   

                    </Grid>
                  </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Schedule Access:</Typography>
                  </Grid>
                  <Grid item xs={8} sx={{maxWidth:'350px'}}>
                  <Select
    value={editedUserRole?.scheduleaccess}
    onChange={(e) =>
      setEditedUserRole((prev) => ({
        ...prev,
        scheduleaccess: e.target.value,
        id: userRole ? userRole.id : undefined,
        rolename: editedUserRole?.rolename || '',
        status: editedUserRole?.status || '',
        projectaccess: editedUserRole?.projectaccess || '',
        modulesaccess: editedUserRole?.modulesaccess || '',
        reportsaccess: editedUserRole?.reportsaccess || '',
        note: editedUserRole?.note || '',
        createdon: editedUserRole?.createdon || '',
      }))
    }
    sx={{
      width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
      maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
    }}
    fullWidth
  >
    {ACCESS_CHOICES.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </Select>
                    
                    </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Module Access:</Typography>
                  </Grid>
                  <Grid item xs={8} sx={{maxWidth:'350px'}}>
                  <Select
    value={editedUserRole?.modulesaccess || ''}
    onChange={(e) =>
      setEditedUserRole((prev) => ({
        ...prev,
        modulesaccess: e.target.value,
        id: userRole ? userRole.id : undefined,
        rolename: editedUserRole?.rolename || '',
        status: editedUserRole?.status || '',
        projectaccess: editedUserRole?.projectaccess || '',
        scheduleaccess: editedUserRole?.scheduleaccess || '',
        reportsaccess: editedUserRole?.reportsaccess || '',
        note: editedUserRole?.note || '',
        createdon: editedUserRole?.createdon || '',
      }))
    }
    sx={{
      width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
      maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
    }}
    fullWidth
  >
    {ACCESS_CHOICES.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </Select>
                     </Grid>
                     </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px', }}>
                  <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Report Access:</Typography>
                  </Grid>
                  <Grid item xs={8} sx={{maxWidth:'350px'}}>
                  <Select
    value={editedUserRole?.reportsaccess || ''}
    onChange={(e) =>
      setEditedUserRole((prev) => ({
        ...prev,
        reportsaccess: e.target.value,
        id: userRole ? userRole.id : undefined,
        rolename: editedUserRole?.rolename || '',
        status: editedUserRole?.status || '',
        projectaccess: editedUserRole?.projectaccess || '',
        scheduleaccess: editedUserRole?.scheduleaccess || '',
        modulesaccess: editedUserRole?.modulesaccess || '',
        note: editedUserRole?.note || '',
        createdon: editedUserRole?.createdon || '',
      }))
    }
    sx={{
      width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
      maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
    }}
    fullWidth
  >
    {REPORT_ACCESS_CHOICES.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </Select>
                    </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ mb: '10px' }}>
  <Grid container spacing={2} alignItems='center'>
    {/* <Grid item xs={4}>
      <Typography>Created On:</Typography>
    </Grid> */}
    <Grid item xs={12} sx={{ mb: '10px' }}>
  <Grid container spacing={2} alignItems='center'>
    <Grid item xs={4}>
      <Typography>Created On:</Typography>
    </Grid>
    <Grid item xs={8} sx={{ maxWidth: '350px' }}>
      <TextField
        value={editedUserRole?.createdon ? editedUserRole.createdon.toString() : ''}
        InputProps={{ readOnly: true }} // Set readOnly to make it non-editable
        onChange={(e) =>
          setEditedUserRole((prev) => ({
            ...prev,
            createdon: e.target.value,
            id: userRole ? userRole.id : undefined,
            rolename: editedUserRole?.rolename || '',
            status: editedUserRole?.status || '',
            projectaccess: editedUserRole?.projectaccess || '',
            scheduleaccess: editedUserRole?.scheduleaccess || '',
            modulesaccess: editedUserRole?.modulesaccess || '',
            reportsaccess: editedUserRole?.reportsaccess || '',
            note: editedUserRole?.note || '',
          }))
        }
        sx={{
          width: isEditing ? '350px' : '350px', // Adjust the width based on edit mode
          maxWidth: isEditing ? '350px' : '350px', // Set maximum width based on edit mode
        }}
        fullWidth
      />
    </Grid>
  </Grid>
</Grid>
  </Grid>
</Grid>
                  </Grid>
                 
                </>
                
              ) : (
                <>
                  
              <Grid item xs={12} sx={{ mb: '20px', }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4} >
                    <Typography>Role Name:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.rolename}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Status:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.status}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Note:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.note}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Project Access:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.projectaccess}</Typography>
                  </Grid>
                </Grid>
              </Grid>
             
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Schedule Access:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.scheduleaccess}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Module Access:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.modulesaccess}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Report Access:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography>{userRole.reportsaccess}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={{ mb: '20px' }}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={4}>
                    <Typography>Created On:</Typography>
                  </Grid>
                  <Grid item xs={8}>
                  <Typography>{userRole.createdon ? userRole.createdon.toString() : ''}</Typography>

                  </Grid>
                </Grid>
              </Grid>
            

                  {/* Render other non-editable fields similarly */}
                </>
              )}
 {isEditing && (
           <Box
           sx={{
             position: 'absolute',
             top: '100px', // Adjust the top position as needed
             right: '10px',
             zIndex: 1, // Ensure a higher z-index
           }}
         >
           
         </Box>
         
        )}
              {/* Save and Cancel buttons in edit mode */}
          {isEditing && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '20px',
                marginBottom: '10px',
              }}
            ><Button onClick={handleSave}  variant="contained" sx={{ marginRight: 1 ,'&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}>
            Save
          </Button>
              <Button onClick={handleCancel}  variant="contained" >
                Cancel
              </Button>
              
            </Box>

            
          )}
            
          </Box>
        ) : (
          null
        )}
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
};

export default ViewRolePage;
